import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CALENDLY, PHONE } from 'constants/routes';
import Heading from 'components/shared/Heading';
import HomePageButtonGeneral from '../HomePageButtonGeneral';
import { Icon } from '../../shared';


const propTypes = {
    calendlyUrl: PropTypes.string,
};

const defaultProps = {
    calendlyUrl: null,
};

function MoreInfo({ calendlyUrl }) {
    return (
        <MoreInfoContainer>
            <StyledHeading>Need more information?</StyledHeading>
            <Text>
                Whether you are an investor or broker, contact us anytime to request more information. Need to speak with
                someone?
            </Text>
            <ButtonWrapper>
                <HomePageButtonGeneral href={PHONE} target="_blank">
                    <WrappedPhoneIcon icon='phone' />{'(866) 942 4366'}</HomePageButtonGeneral>
                <HomePageButtonGeneral href={CALENDLY} type="secondary"> <WrappedCalendarIcon icon="calendar" /> Schedule a call</HomePageButtonGeneral>
            </ButtonWrapper>
        </MoreInfoContainer>
    );
}

MoreInfo.propTypes = propTypes;
MoreInfo.defaultProps = defaultProps;

const WrappedPhoneIcon = styled(Icon)`
  margin-right: 10px;
`;

const WrappedCalendarIcon = styled(Icon)`
  margin-right: 10px;
  margin-bottom: 2px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const MoreInfoContainer = styled.section`
  padding: 20px 0 40px;
  width: 100%;
  background-color: #eff3f8;
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 30px;
  text-align: center;
  font-weight: 700;
  font-size: var(--font-size-l);
  color: var(--color-primary);
`;

const Text = styled.p`
  text-align: center;
  font-weight: 300;
  font-size: var(--font-size-s);
  color: var(--color-secondary-text);
  margin: 0px auto 35px;
`;

export default MoreInfo;
